import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d9ab288"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-page" }
const _hoisted_2 = { class: "dashboard-overview card border-0 rounded-0 bg-white radius-7 mb-25" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "dashboard-overview__content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "dashboard-overview__eyebrow" }, "Dashboard mensal"),
  /*#__PURE__*/_createElementVNode("h3", { class: "dashboard-overview__title" }, "Visão geral do desempenho"),
  /*#__PURE__*/_createElementVNode("p", { class: "dashboard-overview__description" }, " Receitas e agendamentos dos usuários que você pode ver. ")
], -1))
const _hoisted_6 = { class: "dashboard-overview__stats" }
const _hoisted_7 = { class: "dashboard-overview__stat" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dashboard-overview__stat-label" }, "Agendamentos", -1))
const _hoisted_9 = { class: "dashboard-overview__stat" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dashboard-overview__stat-label" }, "Cancelados", -1))
const _hoisted_11 = { class: "dashboard-overview__stat dashboard-overview__stat--wide" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dashboard-overview__stat-label" }, "Previsto no mês", -1))
const _hoisted_13 = { class: "dashboard-overview__stat-meta" }
const _hoisted_14 = { class: "dashboard-overview__stat dashboard-overview__stat--wide" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dashboard-overview__stat-label" }, "Despesas do mês", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "dashboard-overview__stat-meta" }, "Dados gerais da empresa", -1))
const _hoisted_17 = { class: "row dashboard-layout" }
const _hoisted_18 = { class: "col-12 col-xxl-4 dashboard-billing-column" }
const _hoisted_19 = { class: "col-12 col-xxl-8 dashboard-insights-column" }
const _hoisted_20 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MetricsMonthBillingGraphic = _resolveComponent("MetricsMonthBillingGraphic")!
  const _component_CardsDashboardMonth = _resolveComponent("CardsDashboardMonth")!
  const _component_MetricsMonthSendAndReceivedHour = _resolveComponent("MetricsMonthSendAndReceivedHour")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("strong", null, _toDisplayString(_ctx.getCardsDashboardMonth.scheduled), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("strong", null, _toDisplayString(_ctx.getCardsDashboardMonth.canceled), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.getMetricsMonthBillingGraphic.invoicing)), 1),
              _createElementVNode("small", _hoisted_13, " Taxas de pagamento: -" + _toDisplayString(_ctx.getCardsDashboardMonth.tax), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("strong", null, "R$ " + _toDisplayString(_ctx.getCardsDashboardMonth.expense_value), 1),
              _hoisted_16
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_MetricsMonthBillingGraphic)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_CardsDashboardMonth)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_MetricsMonthSendAndReceivedHour)
      ])
    ])
  ]))
}